import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui-components/ui/card";
import { LineChart, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { kpis } from "../mocks";
import { JourneyFilter } from "./journey-filter";
import { KpiCards } from "./kpi-card";
import { LeadsTable } from "./leads-table";
import RankingParent from "./ranking-parent";
import { UsersTable } from "./users-table";

export default function DashboardView() {
  const [journeyFilter, setJourneyFilter] = useState<string>("all");
  const [userRole, setUserRole] = useState<"admin" | "user">("admin"); // Default to admin for demo
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedUser, setSelectedUser] = useState<string | null>(null);

  useEffect(() => {
    const userId = searchParams.get("selectedUser");
    setSelectedUser(userId);
  }, [searchParams]);

  const handleUserSelect = (userId: string) => {
    setSearchParams({ selectedUser: userId });
  };

  const clearSelectedUser = () => {
    setSearchParams({});
    setSelectedUser(null);
  };

  const toggleRole = () => {
    setUserRole(userRole === "admin" ? "user" : "admin");
  };

  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold tracking-tight">
            {userRole === "admin" ? "Dashboard" : "Dashboard"}
            {selectedUser && (
              <span className="ml-4 text-lg font-normal text-muted-foreground">
                Benutzer anzeigen: {selectedUser}
                <button onClick={clearSelectedUser} className="ml-2 p-1 hover:bg-muted rounded-full">
                  <X className="h-4 w-4" />
                </button>
              </span>
            )}
          </h1>
          {/* Dieser Button dient nur zu Demonstrationszwecken, um zwischen Admin- und Benutzeransichten zu wechseln */}
          <button onClick={toggleRole} className="text-xs bg-muted px-2 py-1 rounded-md">
            Andere Ansicht
          </button>
        </div>
        <p className="text-muted-foreground">
          {userRole === "admin"
            ? "Alle Daten auf einem Blick"
            : "Alle Daten auf einem Blick"}
        </p>
      </div>

      {userRole === "admin" && !selectedUser ? (
        <>
          <RankingParent />

          <Card>
            <CardHeader>
              <CardTitle>Benutzer</CardTitle>
              <CardDescription>Alle Vertriebspartner im Überblick</CardDescription>
            </CardHeader>
            <CardContent>
              <UsersTable onUserSelect={handleUserSelect} />
            </CardContent>
          </Card>
        </>
      ) : (
        <>
          <KpiCards kpis={kpis} />

          <div className="grid gap-6 md:grid-cols-2">
            <RankingParent />
            <Card>
              <CardHeader>
                <CardTitle>Verkaufsleistung</CardTitle>
                <CardDescription>KW / Monat / Gesamt</CardDescription>
              </CardHeader>
              <CardContent className="h-[300px] flex items-center justify-center">
                <div className="text-muted-foreground flex flex-col items-center">
                  <LineChart className="h-16 w-16 mb-2" />
                  <p>Leistungsdiagramm wird hier angezeigt</p>
                </div>
              </CardContent>
            </Card>
          </div>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <div>
                <CardTitle>Lead-Verwaltung</CardTitle>
                <CardDescription>Verfolgen und verwalten Sie Ihre Leads</CardDescription>
              </div>
              <JourneyFilter value={journeyFilter} onValueChange={setJourneyFilter} />
            </CardHeader>
            <CardContent>
              <LeadsTable filter={journeyFilter} />
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
}
